import { Container } from 'styles/common';
import MainMenu from 'components/MainMenu';

export default ({ children, showMainMenu = false }) => (
  <>
    {showMainMenu && <MainMenu />}
    <Container menuVisible={showMainMenu}>{children}</Container>
  </>
);
